import "../../styles/empManagement.css";
import React, { useState, useEffect } from "react";
import { BsThreeDots } from "react-icons/bs";
import axios from "axios";
import { Link } from "react-router-dom";
import avatar from "../../assets/images/avatar.webp";
import { truncateEmployeeName } from "./../../utils/employeeUtils";

const EmployeeCard = ({ selectedCompany, searchQuery, selectedFilter }) => {
  const [employeeData, setEmployeeData] = useState([]);

  const getEmployeeData = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      let apiUrl = "";

      const permissions = JSON.parse(localStorage.getItem("userPermissions"));
      const hasViewAllPermission = permissions.some(
        (permission) =>
          permission.name === "view_per_group_all_employees_info" ||
          permission.name === "view_all_managed_employees_info",
      );

      if (hasViewAllPermission) {
        apiUrl = permissions.some(
          (permission) =>
            permission.name === "view_per_group_all_employees_info",
        )
          ? `${process.env.REACT_APP_BASE_URL}/employees/employeeInformation?company=${selectedCompany}`
          : `${process.env.REACT_APP_BASE_URL}/employees/employeesDataForManagers`;

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        const data = response.data?.data;
        const employees = data ? data.flatMap((item) => item.users) : [];

        let filteredAndSortedEmployees = [...employees];

        if (selectedFilter === "Active") {
          filteredAndSortedEmployees = employees.filter(
            (employee) => employee.is_active === 1,
          );
        } else if (selectedFilter === "In Active") {
          filteredAndSortedEmployees = employees.filter(
            (employee) => employee.is_active === 0,
          );
        }

        if (selectedFilter === "Sort By Name") {
          filteredAndSortedEmployees.sort((a, b) =>
            a.employee_full_name.localeCompare(b.employee_full_name),
          );
        } else if (selectedFilter === "Sort By Employee ID") {
          filteredAndSortedEmployees.sort((a, b) =>
            compareAlphanumeric(a.employee_id, b.employee_id),
          );
        }

        setEmployeeData(filteredAndSortedEmployees);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const compareAlphanumeric = (a, b) => {
    const numA = parseInt(a.match(/\d+/)[0]);
    const numB = parseInt(b.match(/\d+/)[0]);

    if (numA === numB) {
      return a.localeCompare(b);
    }

    return numA - numB;
  };

  useEffect(() => {
    getEmployeeData();
  }, [selectedCompany, selectedFilter]);

  const filteredEmployees = employeeData.filter((user) =>
    user.employee_full_name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <>
      {filteredEmployees.map((user) => (
        <div
          key={user.id}
          className="group w-[260px] h-fit py-4 px-2 bg-white rounded-2xl border border-gray-100 shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
        >
          <div className="flex justify-between items-center">
            <span
              className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium ${
                user.is_active === 1
                  ? "bg-[var(--secondary-color)]/10 text-[var(--secondary-color)]"
                  : "bg-red-50 text-red-500"
              }`}
            >
              <span
                className={`w-1.5 h-1.5 rounded-full ${
                  user.is_active === 1
                    ? "bg-[var(--secondary-color)]"
                    : "bg-red-500"
                }`}
              />
              {user.is_active === 1 ? "Active" : "Inactive"}
            </span>

            <Link
              to={`/employeedirectory/${user.id}`}
              className="flex items-center justify-center w-7 h-7 rounded-full text-[#808080] hover:bg-gray-100 hover:text-gray-700 transition-colors"
              aria-label="View employee details"
            >
              <BsThreeDots />
            </Link>
          </div>

          <div className="flex flex-col items-center mt-3">
            <img
              className="w-20 h-20 rounded-full object-cover ring-2 ring-offset-2 ring-[var(--secondary-color)]/20"
              src={user.profile_picture || avatar}
              alt={user.employee_full_name}
            />
            <h5 className="text-base font-semibold text-primary-hrms mt-3 text-center">
              {truncateEmployeeName(user.employee_full_name)}
            </h5>
            <p className="text-sm font-normal text-[#686868] text-center">
              {user.roles[0]?.role_name}
            </p>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-100 my-1" />

          <div className="flex flex-col items-center gap-1">
            <span className="px-2 py-0.5 rounded-md bg-gray-50 text-[#686868] text-xs font-medium tracking-wide">
              {user.employee_id}
            </span>
            <p
              className="text-sm font-normal text-[#686868] truncate max-w-full"
              title={user.official_email}
            >
              {user.official_email}
            </p>
          </div>
        </div>
      ))}
    </>
  );
};

export default EmployeeCard;
